var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.enrichedUsers,"value":_vm.value,"label":_vm.label,"item-text":"selectSummary","item-value":"id","error-messages":_vm.errorMessages,"disable":_vm.disabled,"return-object":""},on:{"input":_vm.setUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }